import { Tabs } from "antd";
import CollapseCard from "../../../components/collapseCard";
import { useTaxLegalId } from "../../../contexts/taxLegalCaseStore";
import { TaxLegalReceivablesStore } from "../../../contexts/taxLegalReceivablesStore";
import _t from "../../../lang/translate";
import { receivableUrl } from "../../../services/taxLegalService";
import { useApi } from "../../../services/useApi";
import InvoiceActions from "./invoices";
import OfferForm from "./offers";
import { PaginationedData } from "../../../types/apiTypes";
import { Receivable } from "../../../types/taxLegalTypes";

export default function PricingReceivablesCard() {
  const taxLegalCaseId = useTaxLegalId()
  const [{ data, isLoading }] = useApi<PaginationedData<Receivable>>(receivableUrl(taxLegalCaseId), { data: [] })
  return (
    <TaxLegalReceivablesStore.Provider initialState={data.data}>
      <CollapseCard loading={isLoading} defaultOpen={false} title={<h3 className="mb-0">{_t("economy")}</h3>}>
        <Tabs defaultActiveKey="offer" className="tax-legal-timeline-tabs" >
          <Tabs.TabPane key={"offer"} tab={_t("offer")}>
            <OfferForm />
          </Tabs.TabPane>
          <Tabs.TabPane key="invoice" tab={_t("invoice")}>
            <InvoiceActions />
          </Tabs.TabPane>
        </Tabs>
      </CollapseCard>
    </TaxLegalReceivablesStore.Provider>

  )
}
